import { Box, Tabs, Tab, TabList, Heading } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useDataMetadataContext } from 'valleyBank/domains/page/hooks/DataMetadataContext';

const TABS = [
  {
    key: 'summary' as const,
    label: 'Summary',
    route: '/loan-accounts',
  },
  {
    key: 'underMarginReport' as const,
    label: 'Under Margin Report',
    route: '/loan-accounts/under-margin-report',
  },
];

export type LoanAccountDetailsTab = typeof TABS[number]['key'];

export const LoanAccountsDetailsTabs: React.FC<{
  selectedTab: LoanAccountDetailsTab;
}> = ({ selectedTab }) => {
  const history = useHistory();
  const { portfolioStats } = useDataMetadataContext();
  return (
    <Tabs
      variant="line"
      index={TABS.findIndex(({ key }) => key === selectedTab)}
      colorScheme="blue"
      background="white"
    >
      <TabList>
        {TABS.map(({ key, label, route }) => (
          <Tab key={key} onClick={() => history.push(route)}>
            {key === 'underMarginReport' &&
            portfolioStats?.underMarginStatusCount
              ? `${label} (${portfolioStats.underMarginStatusCount})`
              : label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export const LoanAccountsOverviewTemplate: React.FC<{
  selectedTab: LoanAccountDetailsTab;
  children: React.ReactNode;
}> = ({ selectedTab, children }) => {
  return (
    <>
      <Heading as="h1" size="lg" mb="6px">
        Loan Accounts
      </Heading>
      <LoanAccountsDetailsTabs selectedTab={selectedTab} />
      <Box w="100%" mt="40px">
        {children}
      </Box>
    </>
  );
};
